module.exports = __webpack_public_path__ + "img/icon-error.6bc9e17c.svg";